import { render, staticRenderFns } from "./PrePurchaseAlertModal.vue?vue&type=template&id=5f3b8276"
import script from "./PrePurchaseAlertModal.vue?vue&type=script&lang=js"
export * from "./PrePurchaseAlertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports